import { render, staticRenderFns } from "./GoIcon.vue?vue&type=template&id=0d359e52"
import script from "./GoIcon.vue?vue&type=script&lang=js"
export * from "./GoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports